import * as React from 'react';
import { Select } from 'antd';

import { LanguageToCode } from '../../../../../../../../lib/App';
import InputControlProps from '../InputControlProps';

export interface LanguageInputState {}

export class LanguageInput extends React.Component<
  InputControlProps,
  LanguageInputState
> {
  renderOptions = () => {
    let options: React.ReactElement<any>[] = [];
    for (let key in LanguageToCode) {
      let value = LanguageToCode[key];
      options.push(
        <Select.Option key={key} value={value}>
          {key}
        </Select.Option>,
      );
    }
    return options;
  };

  onValueChanged = (values: string[]) => {
    this.props.onChange('[' + values.join(',') + ']');
  };

  parsePropsValue = () => {
    if (!this.props.value || this.props.value === '[]') {
      return [];
    }

    return this.props.value.startsWith('[') && this.props.value.endsWith(']')
      ? this.props.value.slice(1, -1).split(',')
      : [this.props.value.toString()];
  };

  render() {
    const { placeholder, disabled } = this.props;
    return (
      <Select
        style={{ width: '100%' }}
        mode="multiple"
        onChange={this.onValueChanged}
        placeholder={placeholder}
        value={this.parsePropsValue()}
        allowClear
        showSearch
        disabled={disabled}
      >
        {this.renderOptions()}
      </Select>
    );
  }
}

export default LanguageInput;
